import {DesignBlockFormField} from "../types/base-design-block.types";
import {Validators} from "@angular/forms";

export const designBlockFormFields: Array<DesignBlockFormField> = [
  {
    fieldName: 'title',
    label: 'Название',
    validators: [ Validators.required ],
    isVisible: true
  },
  {
    fieldName: 'comment',
    label: 'Комментарий',
    isVisible: false
  }
]
